import { render, staticRenderFns } from "./EditOrganizer.vue?vue&type=template&id=0003cd85&scoped=true"
import script from "./EditOrganizer.vue?vue&type=script&lang=js"
export * from "./EditOrganizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0003cd85",
  null
  
)

export default component.exports